import('./offcanvas_2.scss')

export default function Offcanvas2(opts={}){
    BaseConstructor.call(this)
    let {container, options={}} = opts
    let elements = {}
    let context = this
    let current_state = false

    if(!container) throw("Offcanvas2 precisa de um container!")

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.updateContent = (contents=[]) =>{
        $(elements.main_content).html('')
        contents.forEach(content=>{
            let el = this.createElement('div', `offcanvas2-content-wrapper ${content.size} pretty-scrollbar scrollbar-white`, content.content)
            $(elements.main_content).append(el)
        })
        
    }

    this.getCurrentState = _ =>{
        return current_state
    }

    

    const generateHandler = _ =>{
        elements.handler_container = context.createElement('div', `offcanvas2-handler-container handler-${options.position || 'right'}`)
        elements.handler_content = context.createElement('div')
        elements.handler_icon = context.createElement('div', '', '')


        $(elements.handler_content).append(elements.handler_icon)
        $(elements.handler_container).append(elements.handler_content)
        

        setHandlerPosition()


        $(elements.handler_container).on('click', _ =>{
            //toggle
            current_state = !current_state
            $(elements.container).toggleClass('show',current_state)
            context.trigger(current_state ? 'open' : 'close')
        })
    }

    const setHandlerPosition = _ =>{
        switch(options.position){
            case "right":
                $(elements.handler_container).css({
                    left: '0px',
                    top:'50%',
                    transform: 'translateX(-100%)'
                })
                break;
            case 'left':
                $(elements.handler_container).css({
                    right: '0px',
                    top:'50%',
                    transform: 'translateX(100%)'
                })
                break;
            default:
                $(elements.handler_container).css({
                    left : '0px',
                    top:'50%'
                })
                break;
        }
    }

    const handlerContent = {
        left: '<i class="fas fa-chevron-right"></i>',
        right: '<i class="fas fa-chevron-left"></i>'
    }

    init()

    function init(){
        elements.container = context.createElement('div', 'offcanvas2-container')
        elements.main_content = context.createElement('div', 'offcanvas2-content-container')
        generateHandler()
        $(elements.container).append(elements.handler_container, elements.main_content)
        $(container).append(elements.container)
    }
    
}

Offcanvas2.prototype = Object.create(BaseConstructor.prototype)